import { render } from "./AuthorAvatar.vue?vue&type=template&id=52d0f556&scoped=true"
import script from "./AuthorAvatar.vue?vue&type=script&lang=js"
export * from "./AuthorAvatar.vue?vue&type=script&lang=js"

import "./AuthorAvatar.vue?vue&type=style&index=0&id=52d0f556&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52d0f556"]])

export default __exports__